export const PAGE_TITLE_KEYS_BY_UMBRACO_IDS: Record<string, string[]> = {
  Home: [
    'f39ae0f9-fffe-48a5-b14d-5e092d9de97c', // FR
    'ce611321-ef52-486a-a32e-476145784f0a', // EN
    'bae9715f-8f48-41d7-a387-3453c73ed417', // BR
  ],
  'TV & VOD': [
    '291db8c7-615b-46e3-83c8-c17311abfd0c', // FR
    '9542bee0-f604-476e-9f84-d54faa9007a6', // EN,
    'c97022a0-42f7-4cbb-a0b9-e04e23794777', // BR
  ],
  Listen: [
    'd32efcf9-8080-4f84-92dc-932d35c025e5', // FR
    '65527049-9cc6-45fa-9ea1-10379930d2e2', // EN,
    '244810c3-84bc-4bad-82d2-55cd958b0288', // BR
  ],
  Learn: [
    'f525314a-3c15-4dd3-b038-4d854f75b60d', // FR
    'ef5f8ab2-1212-46ff-9b34-d3b26b7c2dfa', // EN,
    '76e86a73-413b-4e7e-a08b-b0a108d00a5a', // BR
  ],
};
